<template>
  <div class="container">
    <nav class="sidebar">
      <PortefeuilleSidebar/>
    </nav>
    <div class="main">
      <router-view/>
    </div>
  </div>
</template>

<script>
import PortefeuilleSidebar from '@/components/Portefeuille/Sidebar'

export default {
  components: {
    PortefeuilleSidebar,
  },
  watch: {
    '$route.params.portefeuille' () {
      this.getQuestions()
    },
  },
  created () {
    this.getQuestions()
  },
  methods: {
    async getQuestions () {
      this.$store.commit('inv/QUESTIONS_RESET')
      if (!this.$route.params.portefeuille) {
        return
      }

      try {
        await this.$store.dispatch('inv/getQuestions', this.$route.params.portefeuille)
      } catch (e) {
        // Un refus est affiche par le composant Questions, qui lit l'etat du store.
        // Les autres erreurs meritent un toast.
        if (!this.$store.state.inv.questionsDenied) {
          this.apiError(e)
        }
      }
    },
  },
}
</script>

<style lang="scss" scoped>
.container {
  position: relative;
  height: 100%;
  background: #fff;
}
.inner {
  position: relative;
  background: #fff;
  height: 100%;
}
$sidebar-width: 200px;
.sidebar {
  position: absolute;
  left: 0;
  width: $sidebar-width;
  padding: 1em 10px;
  overflow: auto;
  border-right: 5px solid #f5f5f5;
  height: 100%;
}
.main {
  margin-left: $sidebar-width;
  height: 100%;
  overflow: auto;
}
</style>
